const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoWorkshop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62714 7.24217C8.1724 6.33779 10.2076 5.8289 12.1739 5.83205C14.1038 5.83547 16.3104 6.16799 18.0268 6.9231C19.7223 7.66905 21.1348 8.93121 20.9897 10.8529C20.7977 13.4003 20.1356 15.6553 18.7315 17.2776C17.3101 18.9201 15.196 19.8371 12.2757 19.832C8.81825 19.826 6.74114 18.4978 5.53836 16.696C4.36297 14.9352 4.07367 12.7972 4.00364 11.2397C3.92623 9.5069 5.09426 8.13932 6.62714 7.24217ZM5.10837 11.1899C5.17573 12.6874 5.45341 14.5751 6.4573 16.079C7.43383 17.5419 9.14837 18.7175 12.2776 18.7229C14.9499 18.7275 16.729 17.8996 17.8964 16.5506C19.0812 15.1816 19.7038 13.1986 19.887 10.7692C19.9776 9.56987 19.1381 8.62309 17.5825 7.93874C16.0478 7.26355 14.0037 6.94436 12.1722 6.94111M5.10837 11.1899C5.05753 10.05 5.81723 9.00029 7.18451 8.20006C8.53945 7.40707 10.377 6.93825 12.1722 6.94111",
    fill: "#121212",
    style: {
      fill: "#121212",
      fill: "color(display-p3 0.0706 0.0706 0.0706)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53568 10.8326C7.84517 10.819 8.1074 11.0508 8.12137 11.3504C8.16344 12.2521 8.33662 13.3567 8.93808 14.226C9.51174 15.0552 10.5256 15.7436 12.4399 15.7464C12.7497 15.7469 13.0005 15.9903 13 16.2901C12.9995 16.5898 12.7479 16.8325 12.4382 16.832C10.1908 16.8286 8.80899 15.9909 8.00577 14.83C7.23036 13.7091 7.04539 12.3597 7.00058 11.3993C6.98661 11.0998 7.22618 10.8461 7.53568 10.8326Z",
    fill: "#121212",
    style: {
      fill: "#121212",
      fill: "color(display-p3 0.0706 0.0706 0.0706)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoWorkshop);
export default __webpack_public_path__ + "static/media/bo-workshop.bbb30e5d9cb6a19e81c1ea4494f04270.svg";
export { ForwardRef as ReactComponent };